import { API, handleResponse, axiosInstance } from './helper';
import { ROLES } from '../constants';
import { getUserInfo } from './keycloak';

interface dashboardStatsPaylaod {
  startDateActive: string;
  endDateActive: string;
  patientActiveStartDate: string;
  patientActiveEndDate: string;
  organisationId?: string;
}

interface dashboardRegistrationTrendsPaylaod {
  rangeType: string;
  organisationId?: string;
}

interface dashboardVerificationTrendsPaylaod {
  rangeType: string;
  organisationId?: string;
}

export interface getActiveUsersPayload {
  startDate: string;
  endDate: string;
}

// Helper function to get organisationId from token for practice admins
const getOrganisationIdIfPracticeAdmin = async () => {
  const token = localStorage.getItem('user_access_token') || '';
  if (token) {
    try {
      const userInfo = await getUserInfo(token);
      if (userInfo?.['x-hasura-role'] === ROLES.PRACTISE_ADMIN && userInfo?.['x-hasura-org-id']) {
        return userInfo?.['x-hasura-org-id'];
      }
    } catch (error) {
      console.error('Error parsing token:', error);
    }
  }
  return null;
};

const getDashboardData = () => handleResponse(axiosInstance.get('/get-dashboard-data'));

const getDashboardStatsData = (dashboard_stats_paylaod: dashboardStatsPaylaod) =>
  handleResponse(axiosInstance.post(API.getDashboardStatCardsData, dashboard_stats_paylaod));

const getDashboardDataPractiseAdmin = (dashboard_stats_paylaod: dashboardStatsPaylaod) =>
  handleResponse(
    axiosInstance.post(API.getDashboardStatCardsDataPractiseAdmin, dashboard_stats_paylaod)
  );

const getTotalActiveUsersData = (dashboard_stats_paylaod: getActiveUsersPayload) =>
  handleResponse(axiosInstance.post(API.getTotalActiveUsersData, dashboard_stats_paylaod));

const getDashboardRegistrationtrends = async (
  dashboard_registration_paylaod: dashboardRegistrationTrendsPaylaod
) => {
  // Check if user is Practice Admin
  const organisationId = await getOrganisationIdIfPracticeAdmin();

  // Add organisation ID if practice admin
  if (organisationId) {
    dashboard_registration_paylaod.organisationId = organisationId;
  }

  return handleResponse(
    axiosInstance.post('v2/get-users-registration-trends', dashboard_registration_paylaod)
  );
};

const getDashboardVerificationtrends = async (
  dashboard_verification_paylaod: dashboardVerificationTrendsPaylaod
) => {
  // Check if user is Practice Admin
  const organisationId = await getOrganisationIdIfPracticeAdmin();

  // Add organisation ID if practice admin
  if (organisationId) {
    dashboard_verification_paylaod.organisationId = organisationId;
  }

  return handleResponse(
    axiosInstance.post(API.getUserVerificationTrend, dashboard_verification_paylaod)
  );
};

const getUserCurrentTrends = async (
  dashboard_verification_paylaod: dashboardVerificationTrendsPaylaod
) => {
  // Check if user is Practice Admin
  const organisationId = await getOrganisationIdIfPracticeAdmin();

  // Add organisation ID if practice admin
  if (organisationId) {
    dashboard_verification_paylaod.organisationId = organisationId;
  }

  return handleResponse(
    axiosInstance.post(API.getUserCurrentTrends, dashboard_verification_paylaod)
  );
};

const getEngagementRatesData = async (
  dashboard_verification_paylaod: dashboardVerificationTrendsPaylaod
) => {
  // Check if user is Practice Admin
  const organisationId = await getOrganisationIdIfPracticeAdmin();

  // Add organisation ID if practice admin
  if (organisationId) {
    dashboard_verification_paylaod.organisationId = organisationId;
  }

  return handleResponse(
    axiosInstance.post(API.getEngagementRatesData, dashboard_verification_paylaod)
  );
};

export {
  getDashboardData,
  getDashboardStatsData,
  getDashboardRegistrationtrends,
  getDashboardVerificationtrends,
  getUserCurrentTrends,
  getTotalActiveUsersData,
  getEngagementRatesData,
  getDashboardDataPractiseAdmin
};
